/// <reference types="vite/client" />

/**
 * Módulo para envio de notificações via API serverless.
 * Essas funções chamam rotas no backend (Vercel) para sincronizar dados 
 * com o Discord, Google Sheets e E-mail.
 */

interface RegistrationData {
  user_id: string;
  email: string;
  birth_date: string;
  created_at: string;
}

/**
 * Envia uma notificação para o Discord/Planilha quando um novo cadastro é realizado.
 * É chamada logo após o sucesso da inserção no Supabase.
 */
export const sendRegistrationNotification = async (registration: RegistrationData): Promise<boolean> => {
  try {
    const response = await fetch('/api/discord-notify', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'x-api-secret': import.meta.env.VITE_API_INTERNAL_SECRET || '' 
      },
      body: JSON.stringify({ 
        type: 'registration',
        data: registration
      })
    });
    return response.ok;
  } catch (error) {
    console.error("❌ [DISCORD] Erro de rede ao enviar notificação:", error);
    return false;
  }
};

/**
 * Envia uma notificação quando um cadastro é aprovado ou rejeitado por um Admin/Funcionário.
 * Sincroniza o status na planilha e envia o embed colorido para o Discord.
 */
export const sendStatusUpdateNotification = async (
  userId: string, 
  status: 'approved' | 'rejected',
  approvedBy?: string
): Promise<boolean> => {
  try {
    const response = await fetch('/api/discord-notify', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'x-api-secret': import.meta.env.VITE_API_INTERNAL_SECRET || ''
      },
      body: JSON.stringify({ 
        type: 'status_update',
        data: {
          user_id: userId,
          status,
          approved_by: approvedBy
        }
      })
    });
    return response.ok;
  } catch (error) {
    console.error("❌ [DISCORD] Erro ao enviar atualização:", error);
    return false;
  }
};

/**
 * Envia uma notificação quando um cadastro é deletado permanentemente.
 * Garante que a linha correspondente na planilha do Google também seja removida.
 */
export const sendDeleteNotification = async (userId: string): Promise<boolean> => {
  try {
    const response = await fetch('/api/discord-notify', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'x-api-secret': import.meta.env.VITE_API_INTERNAL_SECRET || ''
      },
      body: JSON.stringify({ 
        type: 'delete',
        data: { user_id: userId }
      })
    });
    return response.ok;
  } catch (error) {
    console.error("❌ [DISCORD] Erro ao enviar notificação de exclusão:", error);
    return false;
  }
};
